import React from 'react'
import { Card, Typography, Divider } from '../ecosystem'

const FamilyManagementCard = ({ title, children }) => {
    return (
        <Card className="family-management-card">
            <div className='family-mgmt-card-title'>
                <Typography type="heading-01" tag="h3" color="$color-secondary-a2">{title}</Typography>
            </div>
            <Divider
                mLeft="none"
                mRight="none"
                mTop="small"
                mBottom="small"
            />
            <div className="family-mgmt-card-body">
                {children}
            </div>
        </Card>
    )
}

export default FamilyManagementCard
